import { SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA } from 'rebook/apps/search/constants';


const initialState = {
  nichesList: [],
  genresList: [],
  tagsList: [],
  genresThemesCount: 0,
  query: null,
  isLoading: true,
};

export default function searchGenresThemes(state = initialState, action) {
  switch (action.type) {
    case SEARCH_SEARCH_GENRES_AND_THEMES_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
